import { FunctionComponent, PropsWithChildren, forwardRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';

const sxStyles = {
    root: {
        maxWidth: '1200px',
        margin: '0 auto',
        boxShadow: '0px 20px 60px 2px rgba(0, 60, 145, 0.10)',
    },
    tab: {
        backgroundColor: '#fff',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
    },
    tabs: {
        marginLeft: 2,
        marginRight: 2,
    },
};

type NavTabProps = PropsWithChildren<{
    href: string;
}>;

const NavTab = forwardRef<HTMLAnchorElement, NavTabProps>(({ href, children, ...props }, ref) => {
    return (
        <Link ref={ref} to={href} {...props}>
            <Typography component="span" variant="inherit" sx={{ fontSize: '14px' }}>
                {children}
            </Typography>
        </Link>
    );
});

const NAVIGATION = [
    {
        href: '/',
        label: 'Single search',
    },
    {
        href: '/multi-search',
        label: 'Multi search',
    },
];

const NavTabs: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { pathname } = useLocation();

    return (
        <Box sx={sxStyles.root}>
            <Tabs value={value(pathname)} sx={sxStyles.tab} variant="fullWidth">
                {NAVIGATION.map(({ href, label }) => (
                    <Tab
                        LinkComponent={NavTab}
                        wrapped
                        sx={sxStyles.tabs}
                        key={href}
                        href={href}
                        label={label}
                        value={href}
                    />
                ))}
            </Tabs>

            {children}
        </Box>
    );
};

export default NavTabs;

const value = (pathname: string) => {
    return pathname.split('/').slice(0, 2).join('/');
};
